import { Injectable } from '@angular/core';
import {ApiClass} from "@data/class/api-class";
import {IResponseArray} from "@data/interfaces/iresponseArray.interface";
import {environment} from "@env/environment";
import {catchError, map, of} from "rxjs";
import {IRoleList} from "@modules/private/admin/data/interfaces/irole.interface";

@Injectable({
  providedIn: 'root'
})
export class ApiRoleService extends ApiClass {

  constructor() {
    super()
    this.path = 'roles'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    const response: IRoleList = {error: true, msg: '', data: [], total: 0, status: 200, page: 1, itemsByPage: 10, totalItems: 0}
    return this.http.post<IResponseArray>(environment.apiUrl + this.path, {page, limit, filters}).pipe(
      map((r) => r as IRoleList),
      catchError((e) => of(response))
    )
  }
}
